module.exports = __webpack_public_path__ + "img/americanExpress.cba282af.svg";